function init() {
	window.addEventListener('message', (e) => {
		if (typeof e.data !== 'string') {
			return;
		}

		let data = (function(raw) {
			try {
				return JSON.parse(raw);
			} catch (err) {
				return false;
			}
		}(e.data));

		if (data && data.type === 'dfpCallback' && typeof data.action === 'string') {
			window.advert.pubsub.publish(data.action, data.options);
		}
	});
}

module.exports = {
	init
};
